import { css } from 'lit';

export const customerTelegramPageStyles = css`
  ol {
    padding-left: var(--list-indent);
  }

  ol li + li {
    margin-top: var(--space-2);
  }

  .card + .notice {
    margin-top: var(--space-4);
  }
`;
